import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

import { Link } from "react-router-dom";


export default function SliderResults2026() {
    return (
        <>
            <Swiper
                slidesPerView={1}
                spaceBetween={10}

                autoplay={{
                    delay: 4500,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    '@0.00': {
                        slidesPerView: 1,
                        spaceBetween: 10,
                    },
                    '@0.75': {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    '@1.00': {
                        slidesPerView: 4,
                        spaceBetween: 30,
                    },
                    '@1.50': {
                        slidesPerView: 4,
                        spaceBetween: 30,
                    },
                }}
                modules={[Autoplay]}
                className="mySwiper"
            >
                <div className="center">
                    <SwiperSlide>
                        <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                            <img src="assets/sa/Class Nursery.webp" className="img-fluid" alt="Result" />
                            <div className="overlay" />
                            
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                            <img src="assets/sa/Class LKG.webp" className="img-fluid" alt="Result" />
                            <div className="overlay" />
                            
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                            <img src="assets/sa/Class UKG.webp" className="img-fluid" alt="Result" />
                            <div className="overlay" />
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                            <img src="assets/sa/Class 1st.webp" className="img-fluid" alt="Result" />
                            <div className="overlay" />
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                            <img src="assets/sa/Class 2nd.webp" className="img-fluid" alt="Result" />
                            <div className="overlay" />
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                            <img src="assets/sa/Class 3rd.webp" className="img-fluid" alt="Result" />
                            <div className="overlay" />
                            
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                            <img src="assets/sa/Class 4th.webp" className="img-fluid" alt="Result" />
                            <div className="overlay" />
                            
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                            <img src="assets/sa/Class 6th.webp" className="img-fluid" alt="Result" />
                            <div className="overlay" />
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                            <img src="assets/sa/Class 7th.webp" className="img-fluid" alt="Result" />
                            <div className="overlay" />
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                            <img src="assets/sa/Class 9th.webp" className="img-fluid" alt="Result" />
                            <div className="overlay" />
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                            <img src="assets/sa/Class 11th.webp" className="img-fluid" alt="Result" />
                            <div className="overlay" />
                        </div>
                    </SwiperSlide>


                </div>
            </Swiper>
        </>
    );
}
